import { store } from 'src/store';
import { accountsService } from 'src/services/accountsService';
import { usersService } from 'src/services/usersService';
import { ROLES } from 'src/constants/roles';

const getUser = (): Record<string, any> => {
  let user: any = localStorage.getItem('user');
  user = user && user !== 'undefined' && JSON.parse(user);

  return user || {};
};

const getAccessToken = () => {
  const user = getUser();

  return user && (user.access || user.access_token);
};

export const accountLoader = async (): Promise<null> => {
  const raw = localStorage.getItem('COMPANY_ID') || '';
  const companyId: number | string = raw ? +raw : '';
  const accessToken = getAccessToken();
  let version = 'v2';

  if (!accessToken) {
    return null;
  }

  const accountPromise = store.dispatch(
    accountsService.endpoints.getAccounts.initiate({ account: companyId }),
  );
  const usersMePromise = store.dispatch(usersService.endpoints.getUsersMe.initiate());

  try {
    const accountResponse = await accountPromise.unwrap();
    const usersMeResponse = await usersMePromise.unwrap();

    if (accountResponse && accountResponse.version) {
      version = accountResponse.version;
    }
    if (usersMeResponse && usersMeResponse.role === ROLES.COSSUPORT_MANAGER) {
      version = localStorage.getItem('API_VERSION') || version;
    }
  } finally {
    localStorage.setItem('API_VERSION', version);
    accountPromise.unsubscribe();
    usersMePromise.unsubscribe();
  }

  return null;
};
